import '@monolith/vendor/backbone/backbone-relational.js'
// Ensures Backbone Relational can find our models by string name
Backbone.Relational.store.addModelScope(window)
